export type MobileOs = 'ios' | 'android' | 'other';

export const detectMobileOs = (): MobileOs => {
  const ua = navigator.userAgent || '';
  if (/android/i.test(ua)) {
    return 'android';
  }
  if (/iPad|iPhone|iPod/i.test(ua)) {
    return 'ios';
  }
  if (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) {
    return 'ios';
  }
  return 'other';
};

/** 将 H5 路由 path 与 query 拼到 Universal Link / App Link 基址上 */
export const buildAppOpenUrl = (
  baseLink: string,
  h5Pathname: string,
  search: string
): string => {
  const trimmed = baseLink.trim();
  if (!trimmed) {
    return '';
  }
  try {
    const base = new URL(trimmed);
    const segment = h5Pathname.startsWith('/') ? h5Pathname.slice(1) : h5Pathname;
    const query = search.startsWith('?') ? search : search ? `?${search}` : '';
    return new URL(`${segment}${query}`, base).toString();
  } catch {
    return trimmed;
  }
};
